import { render, staticRenderFns } from "./ClientProfileDocuments.vue?vue&type=template&id=f3bbfcb4&"
import script from "./ClientProfileDocuments.vue?vue&type=script&lang=js&"
export * from "./ClientProfileDocuments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports